@if (announcement(); as announcement) {
  <div
    class="announcement"
    [class.announcement-running]="announcement?.isRunningText"
    #announcementRef
    >
    @if (type() === 'winterHolidays') {
      <div class="snowflakes">
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
        <div class="snowflake">
          ❅
        </div>
      </div>
    }
    <p class="announcement-text">{{ announcement.announcement }}</p>
    @if (announcement?.isRunningText) {
      <p class="announcement-text">{{ announcement.announcement }}</p>
    }
  </div>
}
